import p1 from '../components/img/cuid.png';
import p2 from '../components/img/tech.png';
import p3 from '../components/img/rafaella.jpg';
import p4 from '../components/img/ternary.png';
import p5 from '../components/img/arandu.png';
import p6 from '../components/img/curated.png';
import p7 from '../components/img/bodegaseptima.png';
import p8 from '../components/img/yanguela.png';
import p9 from '../components/img/carmen.png';
import p10 from '../components/img/life.jpg';
import p11 from '../components/img/unibe.jpg';
import p12 from '../components/img/fossil.png';
import p13 from '../components/img/cocherenting.png';
import p14 from '../components/img/argenprom.png';
import p15 from '../components/img/tequiero.png';
import p16 from '../components/img/angela.png';
import p17 from '../components/img/televam.png';
import p18 from '../components/img/lamason.png';
import p19 from '../components/img/forza.png';
import p20 from '../components/img/smc.png';
import p21 from '../components/img/bellini.png';
import p22 from '../components/img/queen.png';
import p23 from '../components/img/wine.png';
import p24 from '../components/img/jesus.png';
import p25 from '../components/img/zul.jpg';
import p26 from '../components/img/alejo.png';
import p27 from '../components/img/Aldara.jpg';
import p28 from '../components/img/consulting.png';
import p29 from '../components/img/equira.png';
import p30 from '../components/img/flavvrrr.png';
import p31 from '../components/img/sofia.jpg';
import p32 from '../components/img/mused.png';
import p33 from '../components/img/option.png';
import p34 from '../components/img/rentgomotors.jpg';
import p35 from '../components/img/maria.jpg';
import p36 from '../components/img/casaaliso.jpg';
import p37 from '../components/img/market.png';
import p38 from '../components/img/centroestant.png';
import p39 from '../components/img/marketbrand.png';
import p40 from '../components/img/printalot.png';
import p41 from '../components/img/piazza.png';
import p42 from '../components/img/diosmio.png';
import p43 from '../components/img/futura.png';
import p44 from '../components/img/rochambo.png';
import p45 from '../components/img/virgi.png';
import p46 from '../components/img/latir.png';
import p47 from '../components/img/loulavie.png';
import p48 from '../components/img/miami.png';
import p49 from '../components/img/vizzio.png';

const projects = [
  {
    id: 1,
    title: "Cuid",
    image: p1,
    tags: ["Shopify", "Liquid", "React JS", "Make", "Javascript", "Airtable", "HTML", "CSS", "PHP", "SEO", "Stripe", "Klaviyo"],
    demoUrl: "https://cuid.mx/",
  },
  {
    id: 2,
    title: "Cuid Tech",
    image: p2,
    tags: ["Webflow", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO", "Make", "Airtable"],
    demoUrl: "https://cuid.tech/",
  },
  {
    id: 12,
    title: "Fossil Ecuador",
    image: p12,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "PHP", "WooCommerce"],
    demoUrl: "https://www.fossil.com.ec/",
  },
  {
    id: 4,
    title: "Ternary",
    image: p4,
    tags: ["Webflow", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://www.ternarydev.com/",
  },
  {
    id: 5,
    title: "Arandu",
    image: p5,
    tags: ["Wordpress", "Flatsome", "Woocommerce", "CSS", "Javascript", "HTML", "PHP"],
    demoUrl: "https://arandu.com.ar/",
  },
  {
    id: 3,
    title: "Rafaella Proaño",
    image: p3,
    tags: ["Wordpress", "Divi", "CSS", "Javascript", "HTML", "PHP", "WooCommerce"],
    demoUrl: "https://rafaellaproano.com/",
  },
  {
    id: 6,
    title: "Curated",
    image: p6,
    tags: ["Webflow", "CSS", "Javascript", "HTML", "PHP", "jQuery"],
    demoUrl: "https://www.wearecurated.com/",
  },
  {
    id: 7,
    title: "Bodega Septima",
    image: p7,
    tags: ["Wordpress", "Flatsome", "Woocommerce", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://tienda.bodegaseptima.com/",
  },
  {
    id: 8,
    title: "Farmacia Yanguela",
    image: p8,
    tags: ["Prestashop", "CSS", "Javascript", "HTML", "PHP", "jQuery", "Google Analytics"],
    demoUrl: "https://farmaciayanguela.com/",
  },
  {
    id: 9,
    title: "Doña Carmen",
    image: p9,
    tags: ["Prestashop", "CSS", "Javascript", "HTML", "PHP", "Vue JS", "Google Tag Manager"],
    demoUrl: "https://donacarmen.com/es/",
  },
  {
    id: 10,
    title: "Life",
    image: p10,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "PHP"],
    demoUrl: "https://life-urns.com",
  },
  {
    id: 11,
    title: "UNIBE Ecuador",
    image: p11,
    tags: ["Wordpress", "Divi", "CSS", "Javascript", "HTML", "PHP"],
    demoUrl: "https://unibe.edu.ec/",
  },
  {
    id: 13,
    title: "Cocherenting",
    image: p13,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager"],
    demoUrl: "https://cocherenting.es/",
  },
  {
    id: 14,
    title: "Argenprom",
    image: p14,
    tags: ["Prestashop", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager"],
    demoUrl: "https://www.argenprom.com.ar/",
  },
  {
    id: 15,
    title: "Te Quiero Verde",
    image: p15,
    tags: ["Wordpress", "WooCommerce", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager", "Yoast SEO"],
    demoUrl: "https://tequieroverde.com.ec",
  },
  {
    id: 16,
    title: "Angeles Marquez",
    image: p16,
    tags: ["Wordpress", "jQuery", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager", "Yoast SEO"],
    demoUrl: "https://angelesmarquez.es/",
  },
  {
    id: 17,
    title: "Televam",
    image: p17,
    tags: ["Wordpress", "Flatsome", "Woocommerce", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager", "Yoast SEO", "Slider Revolution"],
    demoUrl: "https://www.tevelam.com.ar/",
  },
  {
    id: 18,
    title: "Lamason",
    image: p18,
    tags: ["Wordpress", "Flatsome", "Woocommerce", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager", "Yoast SEO", "Slider Revolution"],
    demoUrl: "https://lamasonagency.com/",
  },
  {
    id: 19,
    title: "Forza",
    image: p19,
    tags: ["Wordpress", "jQuery", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager", "Yoast SEO"],
    demoUrl: "https://sforzamed.com/",
  },
  {
    id: 20,
    title: "SMC",
    image: p20,
    tags: ["Wordpress", "jQuery", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager", "Yoast SEO"],
    demoUrl: "https://www.smc-construcciones.com/",
  },
  {
    id: 21,
    title: "Bellini",
    image: p21,
    tags: ["Wordpress", "Flatsome", "Woocommerce", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager", "Yoast SEO"],
    demoUrl: "https://www.bellinihnos.com.ar/",
  },
  {
    id: 22,
    title: "Queen Tribe",
    image: p22,
    tags: ["Wordpress", "Divi", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager", "Yoast SEO"],
    demoUrl: "https://www.queentribeventures.com/",
  },
  {
    id: 23,
    title: "New Wine",
    image: p23,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "PHP", "Google Analytics", "Google Tag Manager", "Yoast SEO", "Vue JS"],
    demoUrl: "https://www.newwinelive.com/",
  },
  {
    id: 24,
    title: "El Rey Jesus",
    image: p24,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "MysQl", "Google Analytics", "Google Tag Manager", "Yoast SEO", "Slider Revolution"],
    demoUrl: "https://elreyjesus.org/",
  },
  {
    id: 25,
    title: "Zul",
    image: p25,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "MysQl", "Google Analytics", "Google Tag Manager", "Yoast SEO", "Slider Revolution"],
    demoUrl: "https://www.zul.life/",
  },
  {
    id: 26,
    title: "El establo de alejo",
    image: p26,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "MysQl", "Google Analytics", "Google Tag Manager", "Yoast SEO", "Slider Revolution"],
    demoUrl: "https://elestablodealejo.com/",
  },
  {
    id: 27,
    title: "Aldara",
    image: p27,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "MysQl", "Google Analytics", "Google Tag Manager", "Yoast SEO", "Slider Revolution"],
    demoUrl: "https://aldarablanco.es/",
  },
  {
    id: 28,
    title: "Consulting",
    image: p28,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "MysQl", "Google Analytics", "Google Tag Manager", "Yoast SEO", "Slider Revolution"],
    demoUrl: "https://connectconsulting.ec/",
  },
  {
    id: 29,
    title: "Equira",
    image: p29,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "MysQl", "Google Analytics", "Google Tag Manager", "Yoast SEO", "Slider Revolution"],
    demoUrl: "https://equira.com.ec/",
  },
  {
    id: 30,
    title: "Flavvrr",
    image: p30,
    tags: ["Webflow", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://www.flavvrr.com/",
  },
  {
    id: 31,
    title: "Sofia Tamayo",
    image: p31,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "PHP", "Learndash", "WooCommerce"],
    demoUrl: "https://sofiatamayo.com/",
  },
  {
    id: 32,
    title: "Mused",
    image: p32,
    tags: ["Webflow", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://www.mused.design/",
  },
  {
    id: 33,
    title: "Option",
    image: p33,
    tags: ["Webflow", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://www.optionsswing.com/",
  },
  {
    id: 34,
    title: "Rentgomotors",
    image: p34,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "PHP", "WooCommerce"],
    demoUrl: "https://www.rentgomotors.com/",
  },
  {
    id: 35,
    title: "Maria Fernanda",
    image: p35,
    tags: ["Wordpress", "Divi", "CSS", "Javascript", "HTML", "PHP", "WooCommerce", "Google Analytics"],
    demoUrl: "https://mariafernandacastro.com",
  },
  {
    id: 36,
    title: "Casa Aliso",
    image: p36,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "PHP", "Slider Revolution", "WooCommerce", "Google Analytics"],
    demoUrl: "https://www.casaaliso.com/",
  },
  {
    id: 37,
    title: "Market",
    image: p37,
    tags: ["Shopify", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO", "Liquid", "Ruby", "Tailwind"],
    demoUrl: "https://merkimarket.com/",
  },
  {
    id: 38,
    title: "Centro Estant",
    image: p38,
    tags: ["Wordpress", "Woocommerce", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://centroestant.com.ar/",
  },
  {
    id: 39,
    title: "Marketbrand",
    image: p39,
    tags: ["Wordpress", "Woocommerce", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://productospromocionales.com.ar/",
  },
  {
    id: 40,
    title: "Printalot",
    image: p40,
    tags: ["Wordpress", "Woocommerce", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://printalot.com.ar/",
  },
  {
    id: 41,
    title: "Piazza",
    image: p41,
    tags: ["Wordpress", "Woocommerce", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://www.piazzagriferia.com/",
  },
  {
    id: 42,
    title: "Dios Mio Coffee",
    image: p42,
    tags: ["Shopify", "Liquid", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://diosmiocoffee.com/",
  },
  {
    id: 43,
    title: "Futura",
    image: p43,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://futura1.net/",
  },
  {
    id: 44,
    title: "Roshambo",
    image: p44,
    tags: ["Shopify", "Liquid", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://roshambo.com.ar/",
  },
  {
    id: 45,
    title: "Virginity",
    image: p45,
    tags: ["HTML5", "CSS", "Javascript", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://leadersexperiences.com/",
  },
  {
    id: 46,
    title: "Latir",
    image: p46,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://latir2026.boomgaludigital.com/",
  },
  {
    id: 47,
    title: "Loulavie",
    image: p47,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://www.loulavie.com/",
  },
  {
    id: 48,
    title: "Concours",
    image: p48,
    tags: ["Wordpress", "Elementor", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://miamiconcours.com/",
  },
  {
    id: 49,
    title: "Vizzio",
    image: p49,
    tags: ["Shopify", "Liquid", "CSS", "Javascript", "HTML", "Google Analytics", "Google Tag Manager", "SEO"],
    demoUrl: "https://vizzioeyewear.com/",
  },
];

export default projects;
